<button
    class="cmps-icon-button--no-bg"
    cmpsIconButton
    [attr.aria-expanded]="dp.isOpen()"
    [cmpsTooltipTrigger]="_i18n._11246_SET_DUE_DATE | translate"
    (click)="$event.stopPropagation(); dp.toggle()"
>
    <cmps-icon svgIcon="calendar-range"></cmps-icon>
</button>
<!-- for calendar icon -->
<input
    type="text"
    class="sr-only"
    aria-hidden="true"
    ngbDatepicker
    placement="auto"
    [ngModel]="dueDateTime"
    (ngModelChange)="dueDateTimeChange.emit($event)"
    #dp="ngbDatepicker"
/>
<div class="cmps-cdk-d-flex cmps-cdk-pos-relative">
    <!-- for manual input -->
    <input
        type="text"
        class="cmps-form-input cmps-cdk-border-width-0p cmps-cdk-bg-color-transparent"
        [class.cmps-cdk-color-red-100]="overdue === true && completed !== true"
        [class.cmps-cdk-cursor-pointer]="
            dueDateTimeRef2 !== _document.activeElement
        "
        ngbDatepicker
        placement="auto"
        [ngModel]="dueDateTime"
        (ngModelChange)="dueDateTimeChange.emit($event)"
        [ngModelOptions]="{ updateOn: 'blur' }"
        (keydown.enter)="$event.stopPropagation(); $event.target.blur()"
        #dueDateTimeRef="ngbDatepicker"
        #dueDateTimeRef2
    />
    <!-- mainly done to indicate the text changed from a div to an input -->
    <div
        class="cmps-task-list-task-title--input-line cmps-cdk-w-100pct cmps-cdk-pos-absolute cmps-cdk-pos-bottom-0dot25"
        [class.cmps-cdk-bg-color-blue-100]="
            dueDateTimeRef2 === _document.activeElement
        "
    ></div>
</div>
<button
    class="cmps-icon-button--no-bg"
    cmpsIconButton
    [cmpsTooltipTrigger]="
        (important === true
            ? _i18n._11248_REMOVE_IMPORTANCE
            : _i18n._11247_MARK_AS_IMPORTANT
        ) | translate
    "
    (click)="$event.stopPropagation(); importanceClick.emit()"
>
    <cmps-icon
        [class.cmps-cdk-fill-blue-100]="important === true"
        [svgIcon]="important === true ? 'star' : 'star-outline'"
    ></cmps-icon>
</button>
